export default "public/loading.gif";